(() => {
  const placeholderText = 'Zepto Product Personalizer Options will be visible here when the product is configured by the app';
  const normalizeText = element => element.textContent.replace(/\s+/g, ' ').trim();
  let queued = false;
  const hidePlaceholder = () => {
    queued = false;
    if (!document.querySelector('[id^="shopify-section-robship-"]')) return;
    document.body.querySelectorAll('*').forEach(element => {
      if (normalizeText(element) !== placeholderText) return;
      let box = element;
      while (box.parentElement && box.parentElement !== document.body && normalizeText(box.parentElement) === placeholderText) box = box.parentElement;
      box.hidden = true;
      box.style.setProperty('display', 'none', 'important');
    });
  };
  const queue = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(hidePlaceholder);
  };
  const start = () => {
    hidePlaceholder();
    new MutationObserver(queue).observe(document.body, { childList: true, subtree: true, characterData: true });
    document.addEventListener('shopify:section:load', queue);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
